module.exports = __webpack_public_path__ + "img/logo.a010c797.png";